(function () {
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-brw-root]'));
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.dataset.brwReady) return;
    root.dataset.brwReady = '1';

    var ADDON_ID = parseInt(root.dataset.addonVariant, 10) || 0;
    var ADDON_STEP = parseFloat(root.dataset.addonStep) || 0.5;
    var CURRENCY = root.dataset.currency || 'GBP';

    var modal = document.querySelector('[data-brw-modal]');
    var toastEl = document.querySelector('[data-brw-toast]');
    var state = null;

    function money(p) { return (CURRENCY === 'GBP' ? '\u00a3' : '') + (p / 100).toFixed(2); }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    (function hours() {
      var wrap = root.querySelector('[data-brw-status]');
      var text = root.querySelector('[data-brw-status-text]');
      if (!wrap || !text) return;
      var o = parseInt(root.dataset.openHour, 10);
      var c = parseInt(root.dataset.closeHour, 10);
      var h = new Date().getHours();
      var isOpen = h >= o && h < c;
      wrap.classList.add(isOpen ? 'is-open' : 'is-closed');
      text.textContent = isOpen ? 'Open now \u2014 last orders ' + c + ':00'
                                : 'Closed \u2014 we open at ' + o + ':00. Browse and order ahead.';
    })();

    var search = root.querySelector('[data-brw-search]');
    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-brw-section]'));
    var noRes = root.querySelector('[data-brw-noresults]');

    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        var hits = 0;
        sections.forEach(function (sec) {
          var shown = 0;
          sec.querySelectorAll('[data-brw-item]').forEach(function (item) {
            var hay = (item.dataset.title + ' ' + item.dataset.tags).toLowerCase();
            var ok = !q || hay.indexOf(q) > -1;
            item.hidden = !ok;
            if (ok) shown++;
          });
          sec.hidden = shown === 0;
          hits += shown;
        });
        if (noRes) noRes.hidden = hits > 0;
      });
    }

    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-brw-cat]'));
    cats.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = document.getElementById(btn.dataset.brwCat);
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if ('IntersectionObserver' in window && sections.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          cats.forEach(function (c) { c.classList.toggle('is-active', c.dataset.brwCat === e.target.id); });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      sections.forEach(function (s) { io.observe(s); });
    }

    function postCart(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); });
    }

    function quickAdd(btn) {
      var card = btn.closest('[data-brw-open]');
      var variant = parseInt(btn.dataset.variant, 10);
      if (!variant) return;
      btn.disabled = true;
      btn.classList.add('is-busy');
      var title = card.closest('[data-brw-item]').dataset.title;

      postCart([{ id: variant, quantity: 1, properties: {} }])
        .then(function (res) {
          btn.disabled = false;
          btn.classList.remove('is-busy');
          if (!res.ok) { flash(res.data.description || 'Could not add that.'); return; }
          btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 1200);
          flash(title + ' added to your bag');
          syncCart();
        })
        .catch(function () {
          btn.disabled = false;
          btn.classList.remove('is-busy');
          flash('Something went wrong. Please try again.');
        });
    }

    function openModal(card) {
      if (card.dataset.available === 'false') return;
      var product = JSON.parse(card.dataset.product);
      var groups = JSON.parse(card.dataset.groups || '[]');
      state = { product: product, groups: groups, qty: 1, variant: null, variantPrice: null, picks: {} };

      modal.querySelector('[data-brw-modal-title]').textContent = product.title;
      var desc = modal.querySelector('[data-brw-modal-desc]');
      var plain = (product.description || '').replace(/<[^>]*>/g, '').trim();
      desc.textContent = plain;
      desc.hidden = !plain;

      var media = modal.querySelector('[data-brw-modal-media]');
      media.innerHTML = product.featured_image ? '<img src="' + product.featured_image + '&width=800" alt="">' : '';

      buildVariantOptions(product);
      buildGroups(groups);

      modal.querySelector('[data-brw-notes]').value = '';
      modal.querySelector('[data-brw-qty-val]').textContent = '1';
      modal.querySelector('[data-brw-error]').hidden = true;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      recalc();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      state = null;
    }

    function buildVariantOptions(product) {
      var host = modal.querySelector('[data-brw-options]');
      host.innerHTML = '';
      if (product.has_only_default_variant) {
        state.variant = product.variants[0].id;
        state.variantPrice = product.variants[0].price;
        return;
      }
      product.options_with_values.forEach(function (opt, idx) {
        var grp = document.createElement('div');
        grp.className = 'brw-grp';
        grp.dataset.variantOption = idx;
        grp.innerHTML = '<div class="brw-grp__head"><h3 class="brw-grp__title">' + esc(opt.name) +
          '</h3><span class="brw-grp__tag req">Required</span></div><p class="brw-grp__hint">Select 1</p>';
        opt.values.forEach(function (val) {
          var lab = document.createElement('label');
          lab.className = 'brw-opt';
          lab.innerHTML = '<input type="radio" name="brw-opt-' + idx + '" value="' + esc(val) + '">' +
            '<span class="brw-opt__txt"><span class="brw-opt__lab">' + esc(val) + '</span></span>';
          lab.querySelector('input').addEventListener('change', function () {
            grp.querySelectorAll('.brw-opt').forEach(function (o) { o.classList.remove('is-on'); });
            lab.classList.add('is-on');
            grp.classList.remove('is-invalid');
            resolveVariant();
          });
          grp.appendChild(lab);
        });
        host.appendChild(grp);
      });
    }

    function resolveVariant() {
      var chosen = [];
      modal.querySelectorAll('[data-variant-option]').forEach(function (g) {
        var hit = g.querySelector('input:checked');
        chosen.push(hit ? hit.value : null);
      });
      if (chosen.indexOf(null) > -1) { state.variant = null; recalc(); return; }
      var match = state.product.variants.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];
      state.variant = match && match.available ? match.id : null;
      state.variantPrice = match ? match.price : null;
      state.variantUnavailable = !!(match && !match.available);
      recalc();
    }

    function buildGroups(groups) {
      var host = modal.querySelector('[data-brw-groups]');
      host.innerHTML = '';
      state.picks = {};
      groups.forEach(function (g, gi) {
        var max = parseInt(g.max, 10) || 1;
        var min = parseInt(g.min, 10) || 0;
        var required = g.required === true || g.required === 'true';
        var multi = max > 1;
        state.picks[gi] = [];

        var grp = document.createElement('div');
        grp.className = 'brw-grp';
        grp.dataset.groupIndex = gi;
        grp.dataset.required = required ? '1' : '0';
        grp.dataset.min = min;
        var hint = g.helper || (multi ? 'Pick up to ' + max : 'Select 1');
        grp.innerHTML = '<div class="brw-grp__head"><h3 class="brw-grp__title">' + esc(g.label) + '</h3>' +
          '<span class="brw-grp__tag ' + (required ? 'req">Required' : 'opt">Optional') + '</span></div>' +
          '<p class="brw-grp__hint">' + esc(hint) + '</p>';

        (g.options || []).forEach(function (o) {
          var avail = !(o.available === false || o.available === 'false');
          var delta = parseFloat(o.delta) || 0;
          var lab = document.createElement('label');
          lab.className = 'brw-opt' + (avail ? '' : ' is-off');
          lab.innerHTML = '<input type="' + (multi ? 'checkbox' : 'radio') + '" name="brw-g-' + gi + '"' +
            (avail ? '' : ' disabled') + '>' +
            '<span class="brw-opt__txt"><span class="brw-opt__lab">' + esc(o.label) + '</span>' +
            (o.sub ? '<span class="brw-opt__sub">' + esc(o.sub) + '</span>' : '') + '</span>' +
            (delta > 0 ? '<span class="brw-opt__delta">+' + money(delta * 100) + '</span>' : '');
          var input = lab.querySelector('input');
          input.addEventListener('change', function () {
            if (multi) {
              if (input.checked && state.picks[gi].length >= max) {
                input.checked = false;
                flash('You can pick up to ' + max + ' here.');
                return;
              }
              if (input.checked) state.picks[gi].push({ label: o.label, delta: delta });
              else state.picks[gi] = state.picks[gi].filter(function (p) { return p.label !== o.label; });
              lab.classList.toggle('is-on', input.checked);
            } else {
              grp.querySelectorAll('.brw-opt').forEach(function (x) { x.classList.remove('is-on'); });
              lab.classList.add('is-on');
              state.picks[gi] = [{ label: o.label, delta: delta }];
            }
            grp.classList.remove('is-invalid');
            recalc();
          });
          grp.appendChild(lab);
        });
        host.appendChild(grp);
      });
    }

    function extrasPence() {
      var sum = 0;
      Object.keys(state.picks).forEach(function (k) {
        state.picks[k].forEach(function (p) { sum += (p.delta || 0); });
      });
      return Math.round(sum * 100);
    }

    function recalc() {
      if (!state) return;
      var base = state.variantPrice != null ? state.variantPrice : state.product.price;
      var out = modal.querySelector('[data-brw-total]');
      if (out) out.textContent = money((base + extrasPence()) * state.qty);
    }

    function validate() {
      var ok = true, msg = '';
      modal.querySelectorAll('[data-variant-option]').forEach(function (g) {
        if (!g.querySelector('input:checked')) {
          g.classList.add('is-invalid'); ok = false;
          msg = msg || 'Please finish the required choices above.';
        }
      });
      modal.querySelectorAll('[data-group-index]').forEach(function (g) {
        var gi = g.dataset.groupIndex;
        var need = g.dataset.required === '1';
        var min = parseInt(g.dataset.min, 10) || (need ? 1 : 0);
        if (need && (state.picks[gi] || []).length < Math.max(min, 1)) {
          g.classList.add('is-invalid'); ok = false;
          msg = msg || 'Please finish the required choices above.';
        }
      });
      if (ok && state.variantUnavailable) { ok = false; msg = 'That combination is sold out right now.'; }
      if (ok && !state.variant) { ok = false; msg = 'Please choose an option to continue.'; }
      var err = modal.querySelector('[data-brw-error]');
      err.textContent = msg;
      err.hidden = ok;
      return ok;
    }

    function addToBag() {
      if (!validate()) return;
      var btn = modal.querySelector('[data-brw-add]');
      btn.disabled = true;

      var props = {};
      state.groups.forEach(function (g, gi) {
        var picks = state.picks[gi] || [];
        if (picks.length) props[g.label] = picks.map(function (p) { return p.label; }).join(', ');
      });
      var notes = modal.querySelector('[data-brw-notes]').value.trim();
      if (notes) props['Special instructions'] = notes;

      var extras = extrasPence();
      var stamp = 'BRW-' + Date.now().toString(36);
      var title = state.product.title;
      if (extras > 0) props['_brw_ticket'] = stamp;

      var items = [{ id: state.variant, quantity: state.qty, properties: props }];

      if (extras > 0 && ADDON_ID) {
        var named = [];
        Object.keys(state.picks).forEach(function (k) {
          state.picks[k].forEach(function (p) { if (p.delta > 0) named.push(p.label); });
        });
        items.push({
          id: ADDON_ID,
          quantity: Math.round((extras / 100) / ADDON_STEP) * state.qty,
          properties: { 'Added to': title, 'Extras': named.join(', '), '_brw_ticket': stamp }
        });
      }

      postCart(items)
        .then(function (res) {
          btn.disabled = false;
          if (!res.ok) {
            var e = modal.querySelector('[data-brw-error]');
            e.textContent = res.data.description || 'We could not add that. Please try again.';
            e.hidden = false;
            return;
          }
          closeModal();
          flash(title + ' added to your bag');
          syncCart();
        })
        .catch(function () {
          btn.disabled = false;
          var e = modal.querySelector('[data-brw-error]');
          e.textContent = 'Something went wrong. Please try again.';
          e.hidden = false;
        });
    }

    function syncCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-bubble, [data-cart-count], .cart-count').forEach(function (n) {
            n.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('brewnado:cart', { bubbles: true, detail: cart }));
        })
        .catch(function () {});
    }

    function flash(text) {
      if (!toastEl) return;
      toastEl.textContent = text;
      toastEl.hidden = false;
      requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
      clearTimeout(toastEl._t);
      toastEl._t = setTimeout(function () {
        toastEl.classList.remove('is-on');
        setTimeout(function () { toastEl.hidden = true; }, 280);
      }, 2600);
    }

    root.querySelectorAll('[data-brw-quick]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (btn.dataset.simple === 'true') quickAdd(btn);
        else openModal(btn.closest('[data-brw-open]'));
      });
    });

    root.querySelectorAll('[data-brw-open]').forEach(function (card) {
      card.addEventListener('click', function () { openModal(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(card); }
      });
    });

    modal.querySelectorAll('[data-brw-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
    modal.querySelectorAll('[data-brw-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!state) return;
        state.qty = Math.max(1, state.qty + parseInt(b.dataset.brwQty, 10));
        modal.querySelector('[data-brw-qty-val]').textContent = state.qty;
        recalc();
      });
    });
    modal.querySelector('[data-brw-add]').addEventListener('click', addToBag);
  });
})();
